import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFakom = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.7414 14.5H2.00004L2 10.9286M6.7414 14.5L11.4828 3.6129M6.7414 14.5L14.5 7.64516L11.4828 3.6129M6.7414 14.5L6.74136 10.9286M6.7414 2H2.00004V2.40323L2.00004 4.83671M6.7414 2L11.4828 3.6129M6.7414 2L6.7414 4.83671M2 10.9286H6.74136M2 10.9286L2.00003 7.80357M6.74136 10.9286L6.74139 7.80357M2.00003 7.80357H6.74139M2.00003 7.80357L2.00004 4.83671M6.74139 7.80357L6.7414 4.83671M2.00004 4.83671H6.7414",
		stroke: "currentColor",
		strokeOpacity: 1,
		strokeWidth: 1.25,
		strokeLinejoin: "round"
	})
});
export default SvgFakom;
